<template>
  <div class="assign">
    <myDialog :logTitle="'分配调解员'" :showDialog.sync="open" style="z-index: 999">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close(false)"/>
      <div class="main-content">
        <div style="overflow: hidden">
          <div class="table-content">
            <el-card class="box-card">
              <div slot="header" class="card-header">
                <span>待分配调解员列表</span>
              </div>
              <el-table :data="tableData" v-loading="loading" max-height="300">
                <el-table-column label="用户ID" prop="userId"/>
                <el-table-column label="调解员" prop="userName"/>
                <el-table-column label="昵称" prop="nickName"/>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-button size="mini" type="primary" plain :disabled="scope.row.disabled"
                               @click="choose(scope.row)" style="width: 80px">
                      <span v-if="scope.row.disabled === false">选择</span>
                      <span v-else>已选中</span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>
          <div class="choose-list">
            <el-card class="box-card">
              <div slot="header" class="card-header">
                <span>已选中</span>
                <el-button type="primary" plain size="mini" class="card-btn" :disabled="submitDisabled" @click="submit">
                  提交
                </el-button>
              </div>
              <el-table :data="chooseData" v-loading="loading" max-height="300">
                <el-table-column label="用户ID" prop="userId"/>
                <el-table-column label="调解员" prop="userName"/>
                <el-table-column label="昵称" prop="nickName"/>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-button size="mini" type="primary" plain @click="remove(scope.row)" style="width: 80px">移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>
        </div>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'
import {assign, getMediatorRoleUsers} from "@/api/mediation/mediation";

export default {
  name: 'AssignMediator',
  components: {myDialog},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      chooseData: [],
      submitData: [],
      submitDisabled: true,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    close(refresh) {
      this.$emit('close', {open: false, refresh: refresh});
    },
    async getList() {
      this.loading = true
      getMediatorRoleUsers().then(res => {
        const lists = res.data;
        this.tableData = lists.map(i => {
          this.$set(i, 'disabled', false);
          return i;
        });
        this.loading = false;
      })
    },
    choose(row) {
      this.chooseData.push(row);
      this.$set(row, 'disabled', true);
      this.submitDisabled = false;
    },
    remove(row) {
      let removeIndex = this.chooseData.findIndex(item => {
        return item.userId === row.userId
      });
      this.chooseData.splice(removeIndex, 1);

      let recoveryIndex = this.tableData.findIndex(item => {
        return item.userId === row.userId
      });
      this.tableData[recoveryIndex].disabled = false;
      if (this.chooseData.length === 0) {
        this.submitDisabled = true;
      }
    },
    submit() {
      this.submitData = this.chooseData.map(item => {
        this.$set(item, 'recordId', this.recordId);
        return item;
      });
      assign(this.submitData).then(res => {
        if (res.code === 200) {
          this.$message.success("分配成功!");
          this.close(true);
        } else {
          this.$message.error("分配失败!");
        }
      }).catch((err) => {
        this.$message.error("分配失败!");
      });
    },
  }
}
</script>

<style lang="scss">
.assign {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 80%;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .table-content {
      float: left;
    }

    .choose-list {
      float: right;
    }

    .table-content,
    .choose-list {
      width: 48%;
      height: 80%;
      background-color: pink;

      .box-card {
        border: 1px solid #0084ff;
        background-color: #0F1F46;

        .card-header {
          width: 100%;
          height: 30px;
          border-bottom-color: #0084ff;

          span {
            color: rgb(177, 227, 255);
          }

          .card-btn {
            float: right;
            margin-top: -3px;
            background-color: #FFFFFF;

            span {
              color: #1890ff;
            }
          }

          .card-btn:hover {
            background-color: #1890ff;

            span {
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}

</style>>
